// A <tracking-auto> custom element stamps data-tracking-title onto every
// interactive element within its parent. Render it via the `tracking-auto`
// snippet at the top level of a section — its parent is the Shopify section
// wrapper, so every interactive element in the section is a descendant.
class TrackingAuto extends HTMLElement {
  static SELECTOR = "a, button";

  connectedCallback() {
    const title = this.getAttribute("data-title");
    const parent = this.parentElement;
    if (!title || !parent) return;

    parent
      .querySelectorAll(TrackingAuto.SELECTOR)
      .forEach((el) => el.setAttribute("data-tracking-title", title));
  }
}

if (!customElements.get("tracking-auto")) {
  customElements.define("tracking-auto", TrackingAuto);
}
